import { resToImage } from "services/images";

import { Article } from "./types";

export const resToArticle = (res: any): Article => {
  return {
    id: res.id,
    title: res.title ? res.title : "",
    metaDescription: res.metaDescription ?? "",
    metaTitle: res.metaTitle ?? "",
    slug: res.slug ?? "",
    content: res.content ?? "",
    image: res.image ? resToImage(res.image) : null,
    published: res.published ?? false,
    createdAt: res.createdAt ? new Date(res.createdAt) : new Date(),
    updatedAt: res.updatedAt ? new Date(res.updatedAt) : new Date(),
  };
};

export const articleToBody = (data: Article): any => ({
  title: data.title,
  metaDescription: data.metaDescription,
  metaTitle: data.metaTitle,
  slug: data.slug,
  content: data.content,
  imageId: data.image?.id,
});
